import React, { forwardRef, Ref } from 'react';
import { AriaFocusProps } from '../../types/common';
import { DropdownMultiSelect as DropdownMultiSelectNew } from './DropdownMultiSelect';
import { convertOldDropdownMultiSelectProps } from './converter.old';
import type { OldDropdownMultiSelectProps } from './converter.old';

export type DropdownMultiSelectProps<OptionValue> = OldDropdownMultiSelectProps<OptionValue>;
export type DropdownMultiSelect<OptionValue> = OldDropdownMultiSelectProps<OptionValue>;

function DropdownMultiSelectInner<OptionValue extends string | number>(
  props: DropdownMultiSelectProps<OptionValue> & AriaFocusProps,
  ref: Ref<HTMLDivElement>,
) {
  return <DropdownMultiSelectNew {...convertOldDropdownMultiSelectProps(props)} ref={ref} />;
}

export const DropdownMultiSelect = forwardRef(DropdownMultiSelectInner) as (<OptionValue extends string | number>(
  props: DropdownMultiSelectProps<OptionValue> & AriaFocusProps & { ref?: Ref<HTMLDivElement> },
) => JSX.Element) & { displayName?: string };

DropdownMultiSelect.displayName = 'DropdownMultiSelect';
